var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VSpinner',_vm._b({class:['spinner--wrap', { 'no-custom-margin': !_vm.margin }],style:({ ..._vm.marginObj }),attrs:{"message":_vm.message,"font-size":_vm.fontSize,"spacing":_vm.computedSpacing,"text-fg-color":_vm.textFgColor}},'VSpinner',{ ..._vm.$props, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }